// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2e853fcd","453":"9a04ce3a","732":"676992cd","977":"d817c488"}[chunkId] + ".chunk.js";
};